import DashboardPageView from './Pages/DashboardPageView';
import AnalystPage from './Pages/Dashboard/Analyst';
import ResponderPage from './Pages/Dashboard/Responder';
import EventsPageView from './Pages/EventsPageView';
import EventPageView from './Pages/EventPageView';
import MyAccountView from './Pages/MyAccountView';
import UsersPageView from './Pages/UsersPageView';
import LocationsPageView from './Pages/LocationsPageView';
import SensorsPageView from './Pages/SensorsPageView';
import TVModePageView from './Pages/TVModePageView';

export const childrenPageViews = {
  'user/myaccount': MyAccountView,
  'dashboard/analyst': AnalystPage,
  'dashboard/responder': ResponderPage,
  'dashboard/manager': DashboardPageView,
  'dashboard/tv-mode': TVModePageView,
  'query/events': EventsPageView,
  'query/threats': EventPageView,
  'query/suspects': EventPageView,
  'infrastructure/users': UsersPageView,
  'infrastructure/locations': LocationsPageView,
  'infrastructure/sensors': SensorsPageView,
};



// WEBPACK FOOTER //
// ./src/views/pages.js